<script setup lang="ts">
import { ref } from 'vue';

const picker = ref()
</script>

<template>
  <n-date-picker
    ref="picker"
    type="date"
    format="yyyy-MM-dd"
    value-format="yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
    :first-day-of-week="0"
    class="grow"
  ></n-date-picker>
</template>